import toastr from 'toastr';

import * as actions from './actionsTypes';
import errorManage from '../../errorManage';
import messages from '../../messages';
import surveyTemplateServices from './surveyTemplate.services';

export const getSurveyTemplates = (params) => async (dispatch) => {
  dispatch({ type: actions.FETCH_SURVEY_TEMPLATES_REQUEST, payload: true });
  try {
    const response = await surveyTemplateServices.getSurveyTemplates(params);
    dispatch({ type: actions.FETCH_SURVEY_TEMPLATES_SUCCESS, payload: response.data });

  } catch (error) {
    console.error(error);
    errorManage(error, dispatch, actions.FETCH_SURVEY_TEMPLATES_FAILURE);
  } finally {
    dispatch({ type: actions.FETCH_SURVEY_TEMPLATES_REQUEST, payload: false });
  }
};

export const getSurveyTemplateById = (id) => async (dispatch) => {
  dispatch({ type: actions.FETCH_SURVEY_TEMPLATE_REQUEST, payload: true });
  try {
    const response = await surveyTemplateServices.getSurveyTemplate(id);
    dispatch({ type: actions.FETCH_SURVEY_TEMPLATE_SUCCESS, payload: response.data });
  } catch (error) {
    errorManage(error, dispatch, actions.FETCH_SURVEY_TEMPLATE_FAILURE);
  } finally {
    dispatch({ type: actions.FETCH_SURVEY_TEMPLATE_REQUEST, payload: false });
  }
}

export const createSurveyTemplate = (data, history) => async (dispatch) => {
  dispatch({ type: actions.CREATE_SURVEY_TEMPLATE_REQUEST, payload: true });
  try {
    const response = await surveyTemplateServices.saveSurveyTemplate(data);
    dispatch({ type: actions.CREATE_SURVEY_TEMPLATE_SUCCESS, payload: response.data });
    toastr.success(messages.successMessage);
    history.push(`/encuestas/${response.data.id}/update`);
  } catch (error) {
    errorManage(error, dispatch, actions.CREATE_SURVEY_TEMPLATE_FAILURE);
  } finally {
    dispatch({ type: actions.CREATE_SURVEY_TEMPLATE_REQUEST, payload: false });
  }
};

export const updateSurveyTemplate = (id, data) => async (dispatch) => {
  dispatch({ type: actions.UPDATE_SURVEY_TEMPLATE_REQUEST, payload: true });
  try {
    const response = await surveyTemplateServices.editSurveyTemplate(id, data);
    dispatch({ type: actions.UPDATE_SURVEY_TEMPLATE_SUCCESS, payload: response.data });
    toastr.success(messages.successMessage);
  } catch (error) {
    errorManage(error, dispatch, actions.UPDATE_SURVEY_TEMPLATE_FAILURE);
  } finally {
    dispatch({ type: actions.UPDATE_SURVEY_TEMPLATE_REQUEST, payload: false });
  }
}

export const deleteSurveyTemplate = (id) => async (dispatch) => {
  dispatch({ type: actions.FETCH_SURVEY_TEMPLATE_REQUEST, payload: true });
  try {
    await surveyTemplateServices.deleteSurveyTemplate(id);
    dispatch({ type: actions.DELETE_SURVEY_TEMPLATE_SUCCESS, payload: id });
    toastr.success(messages.successMessage);
  } catch (error) {
    errorManage(error, dispatch, actions.DELETE_SURVEY_TEMPLATE_FAILURE);
  } finally {
    dispatch({ type: actions.FETCH_SURVEY_TEMPLATE_REQUEST, payload: false });
  }
}

export const resetSurveyTemplate = () => async (dispatch) => {
  dispatch({ type: actions.FETCH_SURVEY_TEMPLATE_SUCCESS, payload: {} });
}

export const onAddSurveyTemplate = (survey, setItem) => async (dispatch, getState) => {
  const surveyTemplates = getState().surveyTemplate.surveyTemplates;
  if (!surveyTemplates.find(s => s.id === survey.id)) {
    const _data = [...surveyTemplates, survey];
    const _count = _data.length;
    dispatch({ type: actions.FETCH_SURVEY_TEMPLATES_SUCCESS, payload: {data: _data,count: _count} });
    setItem((prev) => ({ ...prev, survey: survey }));
  }
}